var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foreign-info-collection-page"},[_c('div',{staticClass:"page-content"},[_c('foreign-info-collection',{attrs:{"contract-data":_vm.contractData},on:{"submit-success":_vm.onSubmitSuccess,"cancel":_vm.onCancel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }